import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=02632144&scoped=true"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"
import style0 from "./Rate.vue?vue&type=style&index=0&id=02632144&prod&lang=scss&scoped=true"
import style1 from "./Rate.vue?vue&type=style&index=1&id=02632144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02632144",
  null
  
)

export default component.exports